import React, { Fragment } from 'react';
import {compose} from 'redux';
import {connect} from 'react-redux';
import {translate} from 'react-i18next';
import _ from 'lodash';
import { Col,  Form,  Input,  Row, Button } from 'antd';
import EnhancedModal from '../../../../../components/enhanced-modal';
import { MODAL_WIDTH_LG, MODAL_WIDTH_MD, SPAN_FULL } from '../../../../../styles/constants';
import { onCsvHeaderFormDataChange, hideFileMappingWizardCsvHeaderFormModal, submitFileMappingWizardCsvHeaderForm } from './actions';

const mapStateToProps = state => ({
    CsvHeaderFormData: state.scenes.dataManager.fileMapping.components.wizard.shared.CsvHeaderFormData,
    csvHeaderFormVisible: state.scenes.dataManager.fileMapping.components.wizard.shared.csvHeaderFormVisible,
    tempTableName: state.scenes.dataManager.fileMapping.components.wizard.shared.tempTableName,
});

const mapDispatchToProps = dispatch => ({
  onCsvHeaderFormModalHide: () => dispatch(hideFileMappingWizardCsvHeaderFormModal()),
  onSubmitCsvForm: (tableName, originalName, name) => dispatch(submitFileMappingWizardCsvHeaderForm(tableName, originalName, name)),
  onChange: fields => dispatch(onCsvHeaderFormDataChange(fields)),
});

const mapPropsToFields = ({CsvHeaderFormData}) => ({
    nameValue: Form.createFormField({value: CsvHeaderFormData !== null ? CsvHeaderFormData.nameValue : null}),
})

const onFieldsChange = (props, fields) => props.onChange(_.mapValues(fields, ({value}) => value));

const FileMappingWizardCsvHeaderFormModal = ({
    t,
    form,
    csvHeaderFormVisible,
    onCsvHeaderFormModalHide,
    onSubmitCsvForm,
    CsvHeaderFormData,
    tempTableName,
  }) => {
    return (
        <Fragment>
            <EnhancedModal
                visible={csvHeaderFormVisible}
                width={MODAL_WIDTH_MD}
                title={t('data.fileMapping.csvHeaderForm.title')}
                onCancel={onCsvHeaderFormModalHide}
                footer={
                    <Fragment>
                      <Button onClick={onCsvHeaderFormModalHide}>
                        {t('commons.buttons.cancel.title')}
                      </Button>
                      <Button 
                      type='primary' 
                      onClick={() => onSubmitCsvForm(tempTableName, CsvHeaderFormData.beforeEditName, CsvHeaderFormData.nameValue)}
                      >
                        {t('commons.buttons.confirm.title')}
                      </Button>
                    </Fragment>
                }
            >
                <Row type="flex" justify="center">
                    <Col style={{width: MODAL_WIDTH_LG}}>
                        <Form className="advanced-form">
                            <Col span={SPAN_FULL}>
                                <Form.Item
                                    className="form-item-required"
                                    label={t('data.fileMapping.csvHeaderForm.name.label')}
                                >
                                    {form.getFieldDecorator("nameValue")(
                                      <Input 
                                        title={form.getFieldValue("nameValue")}
                                        style={{textTransform: "uppercase"}}
                                      />
                                    )}
                                </Form.Item>
                            </Col>
                        </Form>
                    </Col>
                </Row>
            </EnhancedModal>
        </Fragment>
    );
}

export default compose(
    translate(),
    connect(mapStateToProps, mapDispatchToProps),
    Form.create({mapPropsToFields, onFieldsChange})
    )(FileMappingWizardCsvHeaderFormModal);